$(document).ready(function () {

    /*
        Slick Slider 
    --------------------------*/
    // Fire on Slick Initialize

    $(".js--main-banner").slick({
        slidesToShow: 1,
        lazyLoad: 'ondemand',
        slidesToScroll: 1,
        mobileFirst: true,
        arrows: true,
        dots: true,
        infinite: true,
        cssEase: "linear",
        useTransform: true,
        touchThreshold: 20,
        speed: 500,
        autoplay: true,
        autoplaySpeed: 2500,
    });

    $('.js--offer-banner').slick({
        slidesToShow: 1,
        lazyLoad: 'ondemand',
        slidesToScroll: 1,
        mobileFirst: true,
        infinite: true,
        cssEase: "linear",
        fade: true,
        dots: false,
        useTransform: true,
        touchThreshold: 20,
        speed: 1500,
        autoplay: true,
        autoplaySpeed: 60000,
        prevArrow:"<img class='a-left control-c prev slick-prev' src='static/200/images/icon_carousel_left.png' />",
        nextArrow:"<img class='a-right control-c next slick-next' src='static/200/images/icon_carousel_right.png' />"
    });


    // Fire on Slick Initialize
    $('.js--book-list').on('init', function () {
        $('.js--book-list .slick-item-wrapper').removeClass('slick-item-wrapper');
        $('.js--book-list').css('display', 'block');
    });

    $(".js--book-list").slick({
        slidesToShow: 4,
        lazyLoad: 'ondemand',
        infinite: false,
        slidesToScroll: 4,
        mobileFirst: true,
        arrows: true,
        cssEase: "ease-out",
        useTransform: true,
        touchThreshold: 20,
        speed: 800,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                slidesToShow: 4,
                slidesToScroll: 4,
                arrows: true
                }
            },

            {
                breakpoint: 1199,
                settings: {
                slidesToShow: 5,
                slidesToScroll: 5,
                arrows: true,
                }
            },

            {
                breakpoint: 1399,
                settings: {
                slidesToShow: 6,
                slidesToScroll: 6,
                arrows: true
                }
            },
        ]
    });

    $('.js--sponsor-product').on('init', function () {
        $('.js--sponsor-product .slick-item-wrapper').removeClass('slick-item-wrapper');
        $('.js--sponsor-product').css('display', 'block');
    });

    $(".js--sponsor-product").slick({
        slidesToShow: 7,
        lazyLoad: 'ondemand',
        infinite: false,
        slidesToScroll: 5,
        mobileFirst: true,
        arrows: true,
        cssEase: "ease-out",
        useTransform: true,
        touchThreshold: 20,
        speed: 800,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                slidesToShow: 5,
                slidesToScroll: 5,
                arrows: true
                }
            },

            {
                breakpoint: 1199,
                settings: {
                slidesToShow: 6,
                slidesToScroll: 6,
                arrows: true,
                }
            },

            {
                breakpoint: 1399,
                settings: {
                slidesToShow: 7,
                slidesToScroll: 7,
                arrows: true
                }
            },
        ]
    });

    // Fire on Slick Initialize
    $('#js--related-products').on('init', function () {
        $('#js--related-products .slick-item-wrapper').removeClass('slick-item-wrapper');
        $('#js--related-products').css('display', 'block');
    });

    $("#js--related-products").slick({
        slidesToShow: 5,
        lazyLoad: 'ondemand',
        infinite: false,
        slidesToScroll: 4,
        mobileFirst: true,
        arrows: true,
        cssEase: "ease-out",
        useTransform: true,
        touchThreshold: 20,
        speed: 800,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                slidesToShow: 4,
                slidesToScroll: 4,
                arrows: true
                }
            },

            {
                breakpoint: 1199,
                settings: {
                slidesToShow: 5,
                slidesToScroll: 5,
                arrows: true,
                }
            },

            {
                breakpoint: 1399,
                settings: {
                slidesToShow: 5,
                slidesToScroll: 5,
                arrows: true
                }
            },
        ]
    });

    $('#js--popup-similar-products').slick({
        slidesToShow: 3,
        lazyLoad: 'ondemand',
        infinite: false,
        slidesToScroll: 2,
        mobileFirst: true,
        arrows: true,
        cssEase: "ease-out",
        useTransform: true,
        touchThreshold: 20,
        speed: 800,
    });

    $('.js--sponsor-product').on('init', function () {
        $('.js--sponsor-product .slick-item-wrapper').removeClass('slick-item-wrapper');
        $('.js--sponsor-product').css('display', 'block');
    });

    $(".js--sponsor-product").slick({
        slidesToShow: 7,
        lazyLoad: 'ondemand',
        infinite: false,
        slidesToScroll: 5,
        mobileFirst: true,
        arrows: true,
        cssEase: "ease-out",
        useTransform: true,
        touchThreshold: 20,
        speed: 800,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                slidesToShow: 5,
                slidesToScroll: 5,
                arrows: true
                }
            },

            {
                breakpoint: 1199,
                settings: {
                slidesToShow: 6,
                slidesToScroll: 6,
                arrows: true,
                }
            },

            {
                breakpoint: 1399,
                settings: {
                slidesToShow: 7,
                slidesToScroll: 7,
                arrows: true
                }
            },
        ]
    });

    $('#js--sponsored-category-products-row-1').on('init', function () {
        $('#js--sponsored-category-products-row-1 .slick-item-wrapper').removeClass('slick-item-wrapper');
        $('#js--sponsored-category-products-row-1').css('display', 'block');
    });

    $("#js--sponsored-category-products-row-1").slick({
        slidesToShow: 5,
        lazyLoad: 'ondemand',
        infinite: false,
        slidesToScroll: 4,
        mobileFirst: true,
        arrows: true,
        cssEase: "ease-out",
        useTransform: true,
        touchThreshold: 20,
        speed: 800,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                slidesToShow: 4,
                slidesToScroll: 4,
                arrows: true
                }
            },

            {
                breakpoint: 1199,
                settings: {
                slidesToShow: 5,
                slidesToScroll: 5,
                arrows: true,
                }
            },

            {
                breakpoint: 1399,
                settings: {
                slidesToShow: 5,
                slidesToScroll: 5,
                arrows: true
                }
            },
        ]
    });

    // Fire on Slick Initialize
    $('.js--recommendation-list').on('init', function () {
        $('.js--recommendation-list .slick-item-wrapper').removeClass('slick-item-wrapper');
        $('.js--recommendation-list').css('display', 'block');
    });

    $(".js--recommendation-list").slick({
        slidesToShow: 5,
        lazyLoad: 'ondemand',
        infinite: false,
        slidesToScroll: 4,
        mobileFirst: true,
        arrows: true,
        cssEase: "ease-out",
        useTransform: true,
        touchThreshold: 20,
        speed: 800,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                slidesToShow: 4,
                slidesToScroll: 4,
                arrows: true
                }
            },

            {
                breakpoint: 1199,
                settings: {
                slidesToShow: 5,
                slidesToScroll: 5,
                arrows: true,
                }
            },

            {
                breakpoint: 1399,
                settings: {
                slidesToShow: 5,
                slidesToScroll: 5,
                arrows: true
                }
            },
        ]
    });


    // Fire on Slick Initialize
    $('.js--recently-view').on('init', function () {
        $('.js--recently-view .slick-item-wrapper').removeClass('slick-item-wrapper');
        $('.js--recently-view').css('display', 'block');
    });

    $(".js--recently-view").slick({
        slidesToShow: 6,
        infinite: false,
        lazyLoad: 'ondemand',
        slidesToScroll: 6,
        mobileFirst: true,
        arrows: true,
        cssEase: "ease-out",
        useTransform: true,
        touchThreshold: 20,
        speed: 800,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                slidesToShow: 6,
                slidesToScroll: 6
                }
            },

            {
                breakpoint: 1199,
                settings: {
                slidesToShow: 6,
                slidesToScroll: 6
                }
            },

            {
                breakpoint: 1399,
                settings: {
                slidesToShow: 7,
                slidesToScroll: 7
                }
            },
        ]
    });

    // Fire on Slick Initialize
    $('.js--author-recommended-book').on('init', function () {
        $('.js--author-recommended-book .slick-item-wrapper').removeClass('slick-item-wrapper');
        $('.js--author-recommended-book').css('display', 'block');
    });

    $(".js--author-recommended-book").slick({
        slidesToShow: 4,
        infinite: false,
        slidesToScroll: 2,
        lazyLoad: 'ondemand',
        mobileFirst: true,
        arrows: false,
        cssEase: "linear",
        useTransform: true,
        touchThreshold: 20,
        speed: 500,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                slidesToShow: 4,
                slidesToScroll: 3,
                arrows: true,
                }
            },

            {
                breakpoint: 1399,
                settings: {
                slidesToShow: 5,
                slidesToScroll: 3,
                arrows: true,
                }
            },
        ]
    });

    // Fire on Slick Initialize
    $('.js--similar-books').on('init', function () {
        $('.js--similar-books .slick-item-wrapper').removeClass('slick-item-wrapper');
    });

    $("#js--similar-books").slick({
        slidesToShow: 5,
        infinite: false,
        slidesToScroll: 2,
        lazyLoad: 'ondemand',
        mobileFirst: true,
        arrows: false,
        cssEase: "linear",
        useTransform: true,
        touchThreshold: 20,
        speed: 500,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                slidesToShow: 4,
                slidesToScroll: 4,
                arrows: true,
                }
            },
            {
                breakpoint: 1199,
                settings: {
                slidesToShow: 5,
                slidesToScroll: 5,
                arrows: true,
                }
            },

            {
                breakpoint: 1399,
                settings: {
                slidesToShow: 5,
                slidesToScroll: 5,
                arrows: true,
                }
            },
        ]
    });

    $("#js--similar-category-ebooks").slick({
        slidesToShow: 5,
        infinite: false,
        slidesToScroll: 2,
        lazyLoad: 'ondemand',
        mobileFirst: true,
        arrows: false,
        cssEase: "linear",
        useTransform: true,
        touchThreshold: 20,
        speed: 500,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                slidesToShow: 4,
                slidesToScroll: 4,
                arrows: true,
                }
            },
            {
                breakpoint: 1199,
                settings: {
                slidesToShow: 5,
                slidesToScroll: 5,
                arrows: true,
                }
            },

            {
                breakpoint: 1399,
                settings: {
                slidesToShow: 5,
                slidesToScroll: 5,
                arrows: true,
                }
            },
        ]
    });

    // Similar category list
    $('#js--category-books').slick({
        slidesToShow: 5,
        infinite: false,
        slidesToScroll: 2,
        lazyLoad: 'ondemand',
        mobileFirst: true,
        arrows: false,
        cssEase: 'linear',
        useTransform: true,
        touchThreshold: 20,
        speed: 500,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                slidesToShow: 4,
                slidesToScroll: 4,
                arrows: true,
                }
            },
            {
                breakpoint: 1199,
                settings: {
                slidesToShow: 5,
                slidesToScroll: 5,
                arrows: true,
                }
            },

            {
                breakpoint: 1399,
                settings: {
                slidesToShow: 5,
                slidesToScroll: 5,
                arrows: true,
                }
            },
        ]
    });

    $('#js--category-books-2').slick({
        slidesToShow: 5,
        infinite: false,
        slidesToScroll: 2,
        lazyLoad: 'ondemand',
        mobileFirst: true,
        arrows: false,
        cssEase: 'linear',
        useTransform: true,
        touchThreshold: 20,
        speed: 500,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                slidesToShow: 4,
                slidesToScroll: 4,
                arrows: true,
                }
            },
            {
                breakpoint: 1199,
                settings: {
                slidesToShow: 5,
                slidesToScroll: 5,
                arrows: true,
                }
            },

            {
                breakpoint: 1399,
                settings: {
                slidesToShow: 5,
                slidesToScroll: 5,
                arrows: true,
                }
            },
        ]
    });

    // Fire on Slick Initialize
    $('.js--recently-sold').on('init', function () {
        $('.js--recently-sold .slick-item-wrapper').removeClass('slick-item-wrapper');
        
    });    

    $(".js--recently-sold").slick({
        slidesToShow: 8.5,
        infinite: false,
        slidesToScroll: 5,
        lazyLoad: 'ondemand',
        mobileFirst: true,
        arrows: false,
        cssEase: "linear",
        useTransform: true,
        touchThreshold: 20,
        speed: 500,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                slidesToShow: 6.5,
                slidesToScroll: 4,
                arrows: true,
                }
            },
            {
                breakpoint: 1199,
                settings: {
                slidesToShow: 6.5,
                slidesToScroll: 5,
                arrows: true,
                }
            },

            {
                breakpoint: 1399,
                settings: {
                slidesToShow: 8.5,
                slidesToScroll: 5,
                arrows: true,
                }
            },
        ]
    });

    // Fire on Slick Initialize
    $('.js--category-recently-sold').on('init', function () {
        $('.js--category-recently-sold .slick-item-wrapper').removeClass('slick-item-wrapper');
    });

    $(".js--category-recently-sold").slick({
        slidesToShow: 5,
        infinite: false,
        slidesToScroll: 5,
        lazyLoad: 'ondemand',
        mobileFirst: true,
        arrows: false,
        cssEase: "linear",
        useTransform: true,
        touchThreshold: 20,
        speed: 500,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                slidesToShow: 4,
                slidesToScroll: 4,
                arrows: true,
                }
            },
            {
                breakpoint: 1199,
                settings: {
                slidesToShow: 4,
                slidesToScroll: 4,
                arrows: true,
                }
            },

            {
                breakpoint: 1399,
                settings: {
                slidesToShow: 5,
                slidesToScroll: 5,
                arrows: true,
                }
            },
        ]
    });

    $('#js--recently-books').on('init', function () {
        $('#js--recently-books .slick-item-wrapper').removeClass('slick-item-wrapper');
    });

    $("#js--recently-books").slick({
        slidesToShow: 6.5,
        infinite: false,
        slidesToScroll: 5,
        lazyLoad: 'ondemand',
        mobileFirst: true,
        arrows: false,
        cssEase: "linear",
        useTransform: true,
        touchThreshold: 20,
        speed: 500,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 5.5,
                    slidesToScroll: 4,
                    arrows: true,
                }
            },
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 6.5,
                    slidesToScroll: 5,
                    arrows: true,
                }
            },

            {
                breakpoint: 1399,
                settings: {
                    slidesToShow: 6.5,
                    slidesToScroll: 5,
                    arrows: true,
                }
            },
        ]
    });

    $(".login-registration__slider").slick({
        slidesToShow: 1,
        infinite: true,
        slidesToScroll: 1,
        lazyLoad: 'ondemand',
        mobileFirst: true,
        arrows: false,
        cssEase: "linear",
        useTransform: true,
        touchThreshold: 20,
        speed: 500,
        dots: false,
        fade: true,
        autoplay: true,
        autoplaySpeed: 1500,
    });

    $(".js--my-account-book-list").slick({
        slidesToShow: 4,
        lazyLoad: 'ondemand',
        infinite: false,
        slidesToScroll: 4,
        mobileFirst: true,
        arrows: true,
        cssEase: "ease-out",
        useTransform: true,
        touchThreshold: 20,
        speed: 800,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                slidesToShow: 4,
                slidesToScroll: 4,
                arrows: true
                }
            },

            {
                breakpoint: 1199,
                settings: {
                slidesToShow: 5,
                slidesToScroll: 5,
                arrows: true,
                }
            },

            {
                breakpoint: 1399,
                settings: {
                slidesToShow: 6,
                slidesToScroll: 6,
                arrows: true
                }
            },
        ]
    });

    $('.js--package-list').on('init', function () {
        $('.js--package-list .slick-item-wrapper').removeClass('slick-item-wrapper');
        $('.js--package-list').css('display', 'block');
    });
    $('.js--package-list').slick({
        slidesToShow: 2,
        lazyLoad: 'ondemand',
        infinite: false,
        slidesToScroll: 2,
        mobileFirst: true,
        arrows: true,
        cssEase: "ease-out",
        useTransform: true,
        touchThreshold: 20,
        speed: 800
    });

    $('.js--buyer-list').on('init', function () {
        $('.js--buyer-list .slick-item-wrapper').removeClass('slick-item-wrapper');
        $('.js--buyer-list').css('display', 'block');
    });
    $('.js--buyer-list').slick({
        slidesToShow: 4,
        lazyLoad: 'ondemand',
        infinite: false,
        slidesToScroll: 4,
        mobileFirst: true,
        arrows: true,
        cssEase: "ease-out",
        useTransform: true,
        touchThreshold: 20,
        speed: 800,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                    arrows: true
                }
            },
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 5,
                    arrows: true,
                }
            },
            {
                breakpoint: 1399,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 5,
                    arrows: true
                }
            }
        ]
    });

    $('.js--publisher-list').on('init', function () {
        $('.js--publisher-list .slick-item-wrapper').removeClass('slick-item-wrapper');
        $('.js--publisher-list').css('display', 'block');
    });
    $('.js--publisher-list').slick({
        slidesToShow: 3,
        lazyLoad: 'ondemand',
        infinite: false,
        slidesToScroll: 3,
        mobileFirst: true,
        arrows: true,
        cssEase: "ease-out",
        useTransform: true,
        touchThreshold: 20,
        speed: 800,
        centerPadding: 30,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    arrows: true
                }
            },

            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    arrows: true,
                }
            },

            {
                breakpoint: 1399,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    arrows: true
                }
            }
        ]
    });

    $('.js--recommended-product-list').slick({
        slidesToShow: 4,
        lazyLoad: 'ondemand',
        infinite: false,
        slidesToScroll: 4,
        mobileFirst: true,
        arrows: true,
        cssEase: 'ease-out',
        useTransform: true,
        touchThreshold: 20,
        speed: 800,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                slidesToShow: 4,
                slidesToScroll: 4,
                arrows: true
                }
            },

            {
                breakpoint: 1199,
                settings: {
                slidesToShow: 5,
                slidesToScroll: 5,
                arrows: true,
                }
            },

            {
                breakpoint: 1399,
                settings: {
                slidesToShow: 6,
                slidesToScroll: 6,
                arrows: true
                }
            },
        ]
    });


    /* ..... Electronics Home Page Carousel ..... */

    // Fire on Slick Initialize
    $('.js--top-category-electronics').on('init', function () {
        $('.js--top-category-electronics .slick-item-wrapper').removeClass('slick-item-wrapper');
    });

    $('.js--top-category-electronics').slick({
        slidesToShow: 6,
        infinite: false,
        slidesToScroll: 5,
        lazyLoad: 'ondemand',
        mobileFirst: true,
        arrows: false,
        cssEase: "linear",
        useTransform: true,
        touchThreshold: 20,
        speed: 500,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 6,
                    slidesToScroll: 5,
                    arrows: true,
                }
            },
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 7,
                    slidesToScroll: 6,
                    arrows: true,
                }
            },
            {
                breakpoint: 1399,
                settings: {
                    slidesToShow: 8,
                    slidesToScroll: 6,
                    arrows: true,
                }
            },
        ]
    });

    $('.js--list-electronics').slick({
        slidesToShow: 4,
        infinite: false,
        slidesToScroll: 3,
        lazyLoad: 'ondemand',
        mobileFirst: true,
        arrows: false,
        cssEase: 'linear',
        useTransform: true,
        touchThreshold: 20,
        speed: 500,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 3,
                    arrows: true,
                }
            },
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 4,
                    arrows: true,
                }
            },
            {
                breakpoint: 1399,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 4,
                    arrows: true,
                }
            },
        ]
    });

    // Fire on Slick Initialize
    $('.js--recently-sold-electronics').on('init', function () {
        $('.js--recently-sold-electronics .slick-item-wrapper').removeClass('slick-item-wrapper');
    });

    $('.js--recently-sold-electronics').slick({
        slidesToShow: 5,
        infinite: false,
        slidesToScroll: 4,
        lazyLoad: 'ondemand',
        mobileFirst: true,
        arrows: false,
        cssEase: "linear",
        useTransform: true,
        touchThreshold: 20,
        speed: 500,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 4,
                    arrows: true,
                }
            },
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 6,
                    slidesToScroll: 5,
                    arrows: true,
                }
            },
            {
                breakpoint: 1399,
                settings: {
                    slidesToShow: 7,
                    slidesToScroll: 5,
                    arrows: true
                }
            }
        ]
    });

});


$('#js--notification-category-bar').slick({
    variableWidth: true,
    lazyLoad: 'ondemand',
    infinite: false,
    slidesToScroll: 1,
    mobileFirst: true,
    arrows: true,
    cssEase: 'ease-out',
    useTransform: true,
    speed: 500,

    responsive: [
        {
            breakpoint: 1199,
            settings: {
                slidesToScroll: 2,
            }
        },
    ]
});

$('.js--recently-sold-common').slick({
    slidesToShow: 4,
    lazyLoad: 'ondemand',
    infinite: false,
    slidesToScroll: 4,
    mobileFirst: true,
    arrows: true,
    cssEase: 'ease-out',
    useTransform: true,
    touchThreshold: 20,
    speed: 800,
    responsive: [
        {
            breakpoint: 991,
            settings: {
            slidesToShow: 4,
            slidesToScroll: 4,
            arrows: true
            }
        },

        {
            breakpoint: 1199,
            settings: {
            slidesToShow: 5,
            slidesToScroll: 5,
            arrows: true,
            }
        },

        {
            breakpoint: 1399,
            settings: {
            slidesToShow: 6,
            slidesToScroll: 6,
            arrows: true
            }
        },
    ]
});

$('#js--whishlist-section').slick({
    lazyLoad: 'ondemand',
    infinite: false,
    slidesToScroll: 4,
    mobileFirst: true,
    arrows: true,
    cssEase: 'ease-out',
    useTransform: true,
    touchThreshold: 20,
    speed: 800,
    variableWidth: true,
    responsive: [
        {
            breakpoint: 1199,
            settings: {
                slidesToScroll: 5,
            }
        },
    ]
});

$('#js--best-selling-ebook-section').slick({
    lazyLoad: 'ondemand',
    infinite: false,
    slidesToScroll: 4,
    mobileFirst: true,
    arrows: true,
    cssEase: 'ease-out',
    useTransform: true,
    touchThreshold: 20,
    speed: 800,
    variableWidth: true,
    responsive: [
        {
            breakpoint: 1199,
            settings: {
                slidesToScroll: 5,
            }
        },
    ]
});

// Voucher list
$('.js--gift-voucher-list').slick({
    slidesToShow: 4,
    lazyLoad: 'ondemand',
    infinite: false,
    slidesToScroll: 4,
    mobileFirst: true,
    arrows: true,
    cssEase: 'ease-out',
    useTransform: true,
    touchThreshold: 20,
    speed: 800,
    responsive: [
        {
            breakpoint: 1199,
            settings: {
                slidesToShow: 5,
                slidesToScroll: 5,
                arrows: true,
            }
        },
        {
            breakpoint: 1399,
            settings: {
                slidesToShow: 6,
                slidesToScroll: 6,
                arrows: true
            }
        },
    ]
});

// Rokomari collection list and extra discount list
$('#js--rokomari-collection-list, #js--extra-discount-list').slick({
    slidesToShow: 4,
    lazyLoad: 'ondemand',
    infinite: false,
    slidesToScroll: 4,
    mobileFirst: true,
    arrows: true,
    cssEase: 'ease-out',
    useTransform: true,
    touchThreshold: 20,
    speed: 800,
    responsive: [
        {
            breakpoint: 1199,
            settings: {
                slidesToShow: 5,
                slidesToScroll: 5,
                arrows: true,
            }
        },
        {
            breakpoint: 1399,
            settings: {
                slidesToShow: 6,
                slidesToScroll: 6,
                arrows: true
            }
        },
    ]
});

// Similar Electronics Products
$('#js--similar-product').slick({
    slidesToShow: 5,
    infinite: false,
    slidesToScroll: 3,
    lazyLoad: 'ondemand',
    mobileFirst: true,
    arrows: false,
    cssEase: "linear",
    useTransform: true,
    touchThreshold: 20,
    speed: 500,
    responsive: [
        {
            breakpoint: 991,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 4,
                arrows: true
            }
        },
        {
            breakpoint: 1199,
            settings: {
                slidesToShow: 5,
                slidesToScroll: 5,
                arrows: true
            }
        },

        {
            breakpoint: 1399,
            settings: {
                slidesToShow: 5,
                slidesToScroll: 5,
                arrows: true
            }
        },
    ]
});

$('#js--retailer-page-category').slick({
    slidesToShow: 3.5,
    infinite: false,
    variableWidth: true,
    lazyLoad: 'ondemand',
    mobileFirst: true,
    arrows: true,
    cssEase: "linear",
    useTransform: true,
    touchThreshold: 20,
    speed: 500,
});

$('.js--kids-product-list').slick({
    slidesToShow: 4,
    lazyLoad: 'ondemand',
    infinite: false,
    slidesToScroll: 4,
    mobileFirst: true,
    arrows: true,
    cssEase: 'ease-out',
    useTransform: true,
    touchThreshold: 20,
    speed: 800,
    responsive: [
        {
            breakpoint: 991,
            settings: {
            slidesToShow: 4,
            slidesToScroll: 4,
            arrows: true
            }
        },
        {
            breakpoint: 1399,
            settings: {
            slidesToShow: 5,
            slidesToScroll: 5,
            arrows: true
            }
        },
    ]
});

$('.js--shishu-kishore-product-list').slick({
    slidesToShow: 4,
    lazyLoad: 'ondemand',
    infinite: false,
    slidesToScroll: 4,
    mobileFirst: true,
    arrows: true,
    cssEase: 'ease-out',
    useTransform: true,
    touchThreshold: 20,
    speed: 800,
    responsive: [
        {
            breakpoint: 991,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
            }
        },
        {
            breakpoint: 1199,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 4
            }
        },
        {
            breakpoint: 1399,
            settings: {
                slidesToShow: 5,
                slidesToScroll: 5,
            }
        },
    ]
});

$('.js--shishu-kishore-popular-series, .js--islamic-popular-package').slick({
    slidesToShow: 4,
    lazyLoad: 'ondemand',
    infinite: false,
    slidesToScroll: 4,
    mobileFirst: true,
    arrows: true,
    cssEase: 'ease-out',
    useTransform: true,
    touchThreshold: 20,
    speed: 800,
    responsive: [
        {
            breakpoint: 991,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3
            }
        },
        {
            breakpoint: 1199,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 4
            }
        },
        {
            breakpoint: 1399,
            settings: {
                slidesToShow: 5,
                slidesToScroll: 5
            }
        },
    ]
});

$('#js--upselling-content').slick({
    lazyLoad: 'ondemand',
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 4,
    mobileFirst: true,
    arrows: true,
    cssEase: 'ease-out',
    useTransform: true,
    touchThreshold: 20,
    speed: 800,
});

$(".js--cart-recom-section").slick({
    slidesToShow: 5,
    lazyLoad: 'ondemand',
    infinite: false,
    slidesToScroll: 4,
    mobileFirst: true,
    arrows: true,
    cssEase: "ease-out",
    useTransform: true,
    touchThreshold: 20,
    speed: 800,
    responsive: [
        {
            breakpoint: 991,
            settings: {
            slidesToShow: 4,
            slidesToScroll: 4,
            arrows: true
            }
        },

        {
            breakpoint: 1199,
            settings: {
            slidesToShow: 5,
            slidesToScroll: 5,
            arrows: true,
            }
        },

        {
            breakpoint: 1399,
            settings: {
            slidesToShow: 5,
            slidesToScroll: 5,
            arrows: true
            }
        },
    ]
});

$("#js--stationary-low-priced-products").slick({
    slidesToShow: 5,
    lazyLoad: 'ondemand',
    infinite: false,
    slidesToScroll: 4,
    mobileFirst: true,
    arrows: true,
    cssEase: "ease-out",
    useTransform: true,
    touchThreshold: 20,
    speed: 800,
    responsive: [
        {
            breakpoint: 991,
            settings: {
            slidesToShow: 4,
            slidesToScroll: 4,
            arrows: true
            }
        },

        {
            breakpoint: 1199,
            settings: {
            slidesToShow: 5,
            slidesToScroll: 5,
            arrows: true,
            }
        },

        {
            breakpoint: 1399,
            settings: {
            slidesToShow: 5,
            slidesToScroll: 5,
            arrows: true
            }
        },
    ]
});

$("#js--category-extra-discount-products").slick({
    slidesToShow: 5,
    lazyLoad: 'ondemand',
    infinite: false,
    slidesToScroll: 4,
    mobileFirst: true,
    arrows: true,
    cssEase: "ease-out",
    useTransform: true,
    touchThreshold: 20,
    speed: 800,
    responsive: [
        {
            breakpoint: 991,
            settings: {
            slidesToShow: 4,
            slidesToScroll: 4,
            arrows: true
            }
        },

        {
            breakpoint: 1199,
            settings: {
            slidesToShow: 5,
            slidesToScroll: 5,
            arrows: true,
            }
        },

        {
            breakpoint: 1399,
            settings: {
            slidesToShow: 5,
            slidesToScroll: 5,
            arrows: true
            }
        },
    ]
});

$('.js--favourite-genre-list').slick({
    slidesToShow: 5.5,
    lazyLoad: 'ondemand',
    infinite: false,
    slidesToScroll: 4,
    mobileFirst: true,
    arrows: true,
    cssEase: 'ease-out',
    useTransform: true,
    touchThreshold: 20,
    speed: 800,
    responsive: [
        {
            breakpoint: 991,
            settings: {
                slidesToShow: 3.2,
                slidesToScroll: 3
            }
        },
        {
            breakpoint: 1199,
            settings: {
                slidesToShow: 3.5,
                slidesToScroll: 3
            }
        },
        {
            breakpoint: 1399,
            settings: {
                slidesToShow: 5.5,
                slidesToScroll: 4
            }
        },
    ]
});

$('#js--most-popular-series').slick({
    slidesToShow: 5.5,
    lazyLoad: 'ondemand',
    infinite: false,
    slidesToScroll: 4,
    mobileFirst: true,
    arrows: true,
    cssEase: 'ease-out',
    useTransform: true,
    touchThreshold: 20,
    speed: 800,
    responsive: [
        {
            breakpoint: 991,
            settings: {
                slidesToShow: 3.2,
                slidesToScroll: 3
            }
        },
        {
            breakpoint: 1199,
            settings: {
                slidesToShow: 3.5,
                slidesToScroll: 3
            }
        },
        {
            breakpoint: 1399,
            settings: {
                slidesToShow: 4.25,
                slidesToScroll: 4
            }
        },
    ]
});

$('#js--islami-product-list').slick({
    slidesToShow: 4,
    lazyLoad: 'ondemand',
    infinite: false,
    slidesToScroll: 2,
    mobileFirst: true,
    arrows: true,
    cssEase: 'ease-out',
    useTransform: true,
    touchThreshold: 20,
    speed: 800,
    responsive: [
        {
            breakpoint: 991,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3
            }
        },
        {
            breakpoint: 1199,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3
            }
        },
        {
            breakpoint: 1399,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 4
            }
        },
    ]
});

$('#js--islami-category-list').slick({
    slidesToShow: 5.5,
    lazyLoad: 'ondemand',
    infinite: false,
    slidesToScroll: 4,
    mobileFirst: true,
    arrows: true,
    cssEase: 'ease-out',
    useTransform: true,
    touchThreshold: 20,
    speed: 800,
    responsive: [
        {
            breakpoint: 991,
            settings: {
                slidesToShow: 3.2,
                slidesToScroll: 3
            }
        },
        {
            breakpoint: 1199,
            settings: {
                slidesToShow: 3.5,
                slidesToScroll: 3
            }
        },
        {
            breakpoint: 1399,
            settings: {
                slidesToShow: 4.5,
                slidesToScroll: 4
            }
        },
    ]
});

$('.js--browse-popular-list').slick({
    slidesToShow: 3,
    lazyLoad: 'ondemand',
    infinite: false,
    slidesToScroll: 2,
    mobileFirst: true,
    arrows: true,
    cssEase: 'ease-out',
    useTransform: true,
    touchThreshold: 20,
    speed: 800,
    responsive: [
        {
            breakpoint: 991,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 2
            }
        },
        {
            breakpoint: 1399,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 3
            }
        },
    ]
});

// Book Fair Leaderboard
$('#js--book-fair-leaderboard').slick({
    slidesToShow: 2.5,
    infinite: false,
    slidesToScroll: 2.5,
    lazyLoad: 'ondemand',
    mobileFirst: true,
    arrows: true,
    cssEase: "linear",
    useTransform: true,
    touchThreshold: 20,
    speed: 500,
    responsive: [
        {
            breakpoint: 991,
            settings: {
                slidesToScroll: 2.1
            }
        },
        {
            breakpoint: 1199,
            settings: {
                slidesToScroll: 1.2
            }
        },
        {
            breakpoint: 1399,
            settings: {
                slidesToScroll: 0.63
            }
        }
    ]
});

//boor fair category
$('#js--book-fair-category').slick({
    slidesToShow: 2.5,
    infinite: false,
    slidesToScroll: 2.5,
    lazyLoad: 'ondemand',
    mobileFirst: true,
    arrows: true,
    cssEase: "linear",
    useTransform: true,
    touchThreshold: 20,
    speed: 500,
    responsive: [
        {
            breakpoint: 991,
            settings: {
                slidesToScroll: 1.5,
                slidesToShow: 5,

            }
        },
        {
            breakpoint: 1199,
            settings: {
                slidesToScroll: 2,
                slidesToShow: 6,

            }
        },
        {
            breakpoint: 1399,
            settings: {
                slidesToScroll: 2.2,
                slidesToShow: 7,

            }
        }
    ]
})

$('#js--trending-category').slick({
    slidesToShow: 5,
    lazyLoad: 'ondemand',
    infinite: false,
    slidesToScroll: 4,
    mobileFirst: true,
    arrows: true,
    cssEase: 'ease-out',
    useTransform: true,
    touchThreshold: 20,
    speed: 800,
    responsive: [
        {
            breakpoint: 991,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 3
            }
        },
        {
            breakpoint: 1399,
            settings: {
                slidesToShow: 6,
                slidesToScroll: 5
            }
        },
    ]
});

$('.js--category-home-list').slick({
    slidesToShow: 4,
    lazyLoad: 'ondemand',
    infinite: false,
    slidesToScroll: 4,
    mobileFirst: true,
    arrows: true,
    cssEase: 'ease-out',
    useTransform: true,
    touchThreshold: 20,
    speed: 800,
    responsive: [
        {
            breakpoint: 991,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 4,
                arrows: true
            }
        },
        {
            breakpoint: 1399,
            settings: {
                slidesToShow: 5,
                slidesToScroll: 5,
                arrows: true
            }
        },
    ]
});

$('.js--grand-ramadan-list').slick({
    slidesToShow: 5,
    lazyLoad: 'ondemand',
    infinite: false,
    slidesToScroll: 4,
    mobileFirst: true,
    arrows: true,
    cssEase: 'ease-out',
    useTransform: true,
    touchThreshold: 20,
    speed: 800,
    responsive: [
        {
            breakpoint: 991,
            settings: {
                slidesToShow: 5,
                slidesToScroll: 4,
                arrows: true
            }
        },
        {
            breakpoint: 1399,
            settings: {
                slidesToShow: 6,
                slidesToScroll: 5,
                arrows: true
            }
        },
    ]
});

// super deal sell
$('.js--super-deal').slick({
    slidesToShow: 5,
    lazyLoad: 'ondemand',
    infinite: false,
    slidesToScroll: 4,
    mobileFirst: true,
    arrows: true,
    cssEase: 'ease-out',
    useTransform: true,
    touchThreshold: 20,
    speed: 600,
    responsive: [
        {
            breakpoint: 991,
            settings: {
                slidesToShow: 5,
                slidesToScroll: 4,
                arrows: true
            }
        },
        {
            breakpoint: 1399,
            settings: {
                slidesToShow: 6,
                slidesToScroll: 5,
                arrows: true
            }
        },
    ]
});

export function slickAdd(className){
    $(`.${className}`).slick({
        slidesToShow: 5,
        lazyLoad: 'ondemand',
        infinite: false,
        slidesToScroll: 4,
        mobileFirst: true,
        arrows: true,
        cssEase: 'ease-out',
        useTransform: true,
        touchThreshold: 20,
        speed: 600,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 4,
                    arrows: true
                }
            },
            {
                breakpoint: 1399,
                settings: {
                    slidesToShow: 6,
                    slidesToScroll: 5,
                    arrows: true
                }
            },
        ]
    }

    )

}

// clearance sell
$('.js--clearance-list').slick({
    slidesToShow: 6.7,
    lazyLoad: 'ondemand',
    infinite: false,
    slidesToScroll: 4,
    mobileFirst: true,
    arrows: true,
    cssEase: 'ease-out',
    useTransform: true,
    touchThreshold: 20,
    speed: 600,
    responsive: [
        {
            breakpoint: 991,
            settings: {
                slidesToShow: 5,
                slidesToScroll: 4,
                arrows: true
            }
        },
        {
            breakpoint: 1399,
            settings: {
                slidesToShow: 6.8,
                slidesToScroll: 5,
                arrows: true
            }
        },
    ]
});

// Super deal category
$('.js--superdeal-category').slick({
    slidesToShow: 6.7,
    lazyLoad: 'ondemand',
    infinite: false,
    slidesToScroll: 4,
    mobileFirst: true,
    arrows: true,
    cssEase: 'ease-out',
    useTransform: true,
    touchThreshold: 20,
    speed: 600,
    responsive: [
        {
            breakpoint: 991,
            settings: {
                slidesToShow: 5,
                slidesToScroll: 4,
                arrows: true
            }
        },
        {
            breakpoint: 1399,
            settings: {
                slidesToShow: 6.8,
                slidesToScroll: 5,
                arrows: true
            }
        },
    ]
});

// special front list
$('.js--special-frontList').slick({
    slidesToShow: 5,
    lazyLoad: 'ondemand',
    infinite: false,
    slidesToScroll: 4,
    mobileFirst: true,
    arrows: true,
    cssEase: 'ease-out',
    useTransform: true,
    touchThreshold: 20,
    speed: 600,
    responsive: [
        {
            breakpoint: 991,
            settings: {
                slidesToShow: 5,
                slidesToScroll: 4,
                arrows: true
            }
        },
        {
            breakpoint: 1399,
            settings: {
                slidesToShow: 6,
                slidesToScroll: 5,
                arrows: true
            }
        },
    ]
});

$('.js--academic-category-list, .js--academic-class-list').slick({
    slidesToShow: 3.5,
    lazyLoad: 'ondemand',
    infinite: false,
    slidesToScroll: 3,
    mobileFirst: true,
    arrows: true,
    cssEase: 'ease-out',
    useTransform: true,
    touchThreshold: 20,
    speed: 800,
    responsive: [
        {
            breakpoint: 1199,
            settings: {
                slidesToShow: 4.5,
                slidesToScroll: 4
            }
        },
        {
            breakpoint: 1399,
            settings: {
                slidesToShow: 6.25,
                slidesToScroll: 5
            }
        },
    ]
});

$('.js--simple-academic-category-list').slick({
    slidesToShow: 4,
    lazyLoad: 'ondemand',
    infinite: false,
    slidesToScroll: 3,
    mobileFirst: true,
    arrows: true,
    cssEase: 'ease-out',
    useTransform: true,
    touchThreshold: 20,
    speed: 800,
    responsive: [
        {
            breakpoint: 991,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 3
            }
        },
        {
            breakpoint: 1399,
            settings: {
                slidesToShow: 5,
                slidesToScroll: 4
            }
        },
    ]
});

$('#js--gift-voucher-cards').slick({
    slidesToShow: 4,
    infinite: false,
    slidesToScroll: 3,
    lazyLoad: 'ondemand',
    mobileFirst: true,
    arrows: true,
    cssEase: "linear",
    useTransform: true,
    touchThreshold: 20,
    speed: 500,
    responsive: [
        {
            breakpoint: 991,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 3
            }
        },
        {
            breakpoint: 1199,
            settings: {
                slidesToShow: 5,
                slidesToScroll: 4
            }
        },
        {
            breakpoint: 1399,
            settings: {
                slidesToShow: 6,
                slidesToScroll: 5
            }
        }
    ]
});

$('#js--just-for-you-recommendation-products').slick({
    slidesToShow: 4,
    infinite: false,
    slidesToScroll: 4,
    mobileFirst: true,
    arrows: true,
    cssEase: "ease-out",
    useTransform: true,
    touchThreshold: 20,
    speed: 800,
    responsive: [
        {
            breakpoint: 991,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 4,
                arrows: true
            }
        },

        {
            breakpoint: 1199,
            settings: {
                slidesToShow: 5,
                slidesToScroll: 5,
                arrows: true,
            }
        },

        {
            breakpoint: 1399,
            settings: {
                slidesToShow: 6,
                slidesToScroll: 6,
                arrows: true
            }
        },
    ]
});